export const copyQuoteLeaseHTMLTooltip = (dealState, companyName) => {
    const car_detail = dealState.car_detail

    return (
        `
    <div style="width: 260px; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); border: 1px solid #e5e7eb;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 260px; background-color: #ffffff; font-family: Arial, sans-serif; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden;">
      <!-- Car Name -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong style="color: #111827;">${car_detail.year} ${car_detail.make} ${car_detail.model}</strong><br>
          ${car_detail.trim}
        </td>
      </tr>
      
      <!-- MSRP -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">MSRP:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.msrp.toDollarFormat()}</td>
      </tr>
      
      <!-- Total Drive Off -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Total Drive Off:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.amount_due_at_signing.toDollarFormat()}</td>
      </tr>
      
      <!-- Payment -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.monthly_payment.toDollarFormat()}</td>
      </tr>
      
      <!-- Term -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Term:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.term}</td>
      </tr>
      
      <!-- Mileage -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Mileage:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.mileage}/year</td>
      </tr>
      
      <!-- Residual -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Residual:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">
            ${dealState.formatted_quote.residual}%, ${dealState.formatted_quote.residual_value.toDollarFormat()}
        </td>
      </tr>
      
      <!-- Footer -->
      <tr>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; color: #111827; font-size: 12px; font-weight: 700;">
          ${companyName}
        </td>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; text-align: right; color: #6b7280; font-size: 9px;">
          Powered by: <img src="https://res.cloudinary.com/hgjsxpz9b/image/upload/v1770308142/td-logo_ule6rf.png" alt="TrueDesking Logo" style="height: 14px; vertical-align: middle; padding: 2px 8px; border-radius: 3px;">
        </td>
      </tr>
    </table>
    </div>
    <p><br></p>
        `
    )
}

export const copyQuoteFinanceHTMLTooltip = (dealState, companyName) => {
    const car_detail = dealState.car_detail

    return (
        `
    <div style="width: 260px; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); border: 1px solid #e5e7eb;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 260px; background-color: #ffffff; font-family: Arial, sans-serif; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden;">
      <!-- Car Name -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong style="color: #111827;">${car_detail.year} ${car_detail.make} ${car_detail.model}</strong><br>
          ${car_detail.trim}
        </td>
      </tr>
      
      <!-- MSRP -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">MSRP:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.msrp.toDollarFormat()}</td>
      </tr>
      
      <!-- Total Drive Off -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Down Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.amount_due_at_signing.toDollarFormat()}</td>
      </tr>
      
      <!-- Payment -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.monthly_payment.toDollarFormat()}</td>
      </tr>
      
      <!-- Term -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Term:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.term}</td>
      </tr>
      
      <!-- APR -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">APR:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.apr}%</td>
      </tr>
      
      <!-- Footer -->
      <tr>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; color: #111827; font-size: 12px; font-weight: 700;">
          ${companyName}
        </td>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; text-align: right; color: #6b7280; font-size: 9px;">
          Powered by: <img src="https://res.cloudinary.com/hgjsxpz9b/image/upload/v1770308142/td-logo_ule6rf.png" alt="TrueDesking Logo" style="height: 14px; vertical-align: middle; padding: 2px 8px; border-radius: 3px;">
        </td>
      </tr>
    </table>
    </div>
    <p><br></p>
        `
    )
}

export const copyQuoteDealerFinanceHTMLTooltip = (dealState, companyName) => {
    const car_detail = dealState.car_detail

    const firstPaymentWaiverAmount = dealState?.formatted_quote.first_payment_waived_amount || 0
    const rebates = dealState.formatted_quote.rebates.filter(r => r.amount !== '0')

    const totalRebatesAmount = rebates.reduce(function(accumulator, rebate) {
        if (rebate.is_applied) {
            return accumulator + Number(rebate.amount);
        } else {
            return accumulator
        }
    }, 0) + Number(firstPaymentWaiverAmount)

    return (
        `
    <div style="width: 260px; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); border: 1px solid #e5e7eb;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 260px; background-color: #ffffff; font-family: Arial, sans-serif; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden;">
      <!-- Car Name -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong style="color: #111827;">${car_detail.year} ${car_detail.make} ${car_detail.model}</strong><br>
          ${car_detail.trim}
        </td>     
      </tr>
      
      <!-- Lender -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong>${dealState.formatted_quote.lender_name}</strong>
        </td>
      </tr>
      
      <!-- MSRP -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">MSRP:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.msrp.toDollarFormat()}</td>
      </tr>
      
      <!-- Selling Price -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Selling Price:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.selling_price.toDollarFormat()}</td>
      </tr>
      
      <!-- Total Drive Off -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Down Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.amount_due_at_signing.toDollarFormat()}</td>
      </tr>
      
      <!-- Payment -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.monthly_payment.toDollarFormat()}</td>
      </tr>
      
      <!-- Term -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Term:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.term}</td>
      </tr>  

      <!-- Total Rebates -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Total Rebates:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${totalRebatesAmount.toDollarFormat()}</td>
      </tr>       
      
      <!-- Broker Fee -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Broker Fee:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.profit.toDollarFormat()}</td>
      </tr>
      
      <!-- APR -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">APR:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.apr}%</td>
      </tr>
      
      <!-- Footer -->
      <tr>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; color: #111827; font-size: 12px; font-weight: 700;">
          ${companyName}
        </td>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; text-align: right; color: #6b7280; font-size: 9px;">
          Powered by: <img src="https://res.cloudinary.com/hgjsxpz9b/image/upload/v1770308142/td-logo_ule6rf.png" alt="TrueDesking Logo" style="height: 14px; vertical-align: middle; padding: 2px 8px; border-radius: 3px;">
        </td>
      </tr>
    </table>
    </div>
    <p><br></p>
        `
    )
}

export const copyQuoteDealerLeaseHTMLTooltip = (dealState, companyName) => {
    const car_detail = dealState.car_detail

    const firstPaymentWaiverAmount = dealState?.formatted_quote.first_payment_waived_amount || 0
    const rebates = dealState.formatted_quote.rebates.filter(r => r.amount !== '0')
    const totalRebatesAmount = rebates.reduce(function(accumulator, rebate) {
        if (rebate.is_applied) {
            return accumulator + Number(rebate.amount);
        } else {
            return accumulator
        }
    }, 0) + Number(firstPaymentWaiverAmount)

    return (
        `
    <div style="width: 260px; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); border: 1px solid #e5e7eb;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 260px; background-color: #ffffff; font-family: Arial, sans-serif; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden;">
      <!-- Car Name -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong style="color: #111827;">${car_detail.year} ${car_detail.make} ${car_detail.model}</strong><br>
          ${car_detail.trim}
        </td>
      </tr>
      
      <!-- Lender -->
      <tr>
        <td colspan="2" style="padding: 8px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">
          <strong>${dealState.formatted_quote.lender_name}</strong>
        </td>
      </tr>
      
      <!-- MSRP -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">MSRP:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.msrp.toDollarFormat()}</td>
      </tr>
      
      <!-- Selling Price -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Selling Price:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.selling_price.toDollarFormat()}</td>
      </tr>
      
      <!-- Total Drive Off -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Total Drive Off:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.amount_due_at_signing.toDollarFormat()}</td>
      </tr>
      
      <!-- Payment -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Payment:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.monthly_payment.toDollarFormat()}</td>
      </tr>
      
      <!-- Term -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Term:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.term}</td>
      </tr>      
      
      <!-- Mileage -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Mileage:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.mileage}</td>
      </tr>  
       
      <!-- Total Rebates -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Total Rebates:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${totalRebatesAmount.toDollarFormat()}</td>
      </tr>       
      
      <!-- Broker Fee -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Broker Fee:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.profit.toDollarFormat()}</td>
      </tr>
      
      <!-- Money Factor -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Money Factor:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">${dealState.formatted_quote.money_factor}</td>
      </tr>
      
      <!-- Residual -->
      <tr>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 11px;">Residual:</td>
        <td style="padding: 6px 12px; border-bottom: 1px solid #e5e7eb; color: #111827; font-size: 11px; font-weight: 600; text-align: right;">
            ${dealState.formatted_quote.residual}%, ${dealState.formatted_quote.residual_value.toDollarFormat()}
        </td>
      </tr>
      
      <!-- Footer -->
      <tr>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; color: #111827; font-size: 12px; font-weight: 700;">
          ${companyName}
        </td>
        <td style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 8px 12px; text-align: right; color: #6b7280; font-size: 9px;">
          Powered by: <img src="https://res.cloudinary.com/hgjsxpz9b/image/upload/v1770308142/td-logo_ule6rf.png" alt="TrueDesking Logo" style="height: 14px; vertical-align: middle; padding: 2px 8px; border-radius: 3px;">
        </td>
      </tr>
    </table>
    </div>
    <p><br></p>
        `
    )
}

export const copyQuoteHTMLTooltip = (dealState, companyName, isDealer) => {
    if (!isDealer) {
        return dealState.is_purchase ? copyQuoteFinanceHTMLTooltip(dealState, companyName) : copyQuoteLeaseHTMLTooltip(dealState, companyName)
    } else {
        return dealState.is_purchase ? copyQuoteDealerFinanceHTMLTooltip(dealState, companyName) : copyQuoteDealerLeaseHTMLTooltip(dealState, companyName)
    }

}

const getSpaces = (word) => {
    const totalWhiteSpace = 20
    const wordLength = word.length
    return word + " ".repeat(totalWhiteSpace - wordLength)
}

export const buildMiniQuoteSummaryString = (dealState, isDealer) => {
    const isPurchase = dealState.is_purchase

    const firstPaymentWaiverAmount = dealState?.formatted_quote.first_payment_waived_amount || 0
    const rebates = dealState.formatted_quote.rebates.filter(r => r.amount !== '0')

    const totalRebatesAmount = rebates.reduce(function(accumulator, rebate) {
        if (rebate.is_applied) {
            return accumulator + Number(rebate.amount);
        } else {
            return accumulator
        }
    }, 0) + Number(firstPaymentWaiverAmount)

    const driveOffText = isPurchase ? "Down Payment:" : "Total Drive Off:"

    let string = ''
    const car_detail = dealState.car_detail
    string += `${car_detail.year} ${car_detail.make} ${car_detail.model}`
    string += "\n"
    string += `${car_detail.trim}`
    string += "\n"
    if (isDealer) {
        string += `${getSpaces("Lender:")} ${dealState.formatted_quote.lender_name}`
        string += "\n"
    }
    string += `${getSpaces("MSRP:")} ${dealState.msrp.toDollarFormat()}`
    string += "\n"
    if (isDealer) {
        string += `${getSpaces("Selling Price:")} ${dealState.selling_price.toDollarFormat()}`
        string += "\n"
    }
    string += `${getSpaces(driveOffText)} ${dealState.formatted_quote.amount_due_at_signing.toDollarFormat()}`
    string += "\n"
    string += `${getSpaces("Payment:")} ${dealState.formatted_quote.monthly_payment.toDollarFormat()}`
    string += "\n"
    string += `${getSpaces("Term:")} ${dealState.term}`
    string += "\n"
    if (isDealer) {
        string += `${getSpaces("Total Rebates:")} ${totalRebatesAmount.toDollarFormat()}`
        string += "\n"
        string += `${getSpaces("Broker Fee:")} ${dealState.profit.toDollarFormat()}`
        string += "\n"
        string += `${getSpaces("Money Factor:")} ${dealState.formatted_quote.money_factor}`
        string += "\n"
    }
    if (isPurchase) {
        string += `${getSpaces("APR:")} ${dealState.formatted_quote.apr}%`
    } else {
        string += `${getSpaces("Mileage:")} ${dealState.mileage}/year`
        string += "\n"
        string += `${getSpaces("Residual:")} ${dealState.formatted_quote.residual}%, ${dealState.formatted_quote.residual_value.toDollarFormat()}`
    }
    return string
}

// Add for Option Codes
// ${car_detail.option_codes.map(oc => `<span>${oc.name}</span>`).join('')}
